import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import moment from 'moment'
import PRSPostItem from './PRSPostItem'
import PRSCostItem from './PRSCostItem'
import PRSPmntItem from './PRSPmntItem'
import PRSSubTotalItem from './PRSSubTotalItem'
import PRSAddPostForm from './PRSAddPostForm'
import PRSAddPmntForm from './PRSAddPmntForm'
import { fnum } from '../../utils/utils'

class PRSForm extends React.Component {

  state = {
    adding: false,
    addingPmnt: false
  }

  startAdd = e => {
    e.preventDefault();
    this.setState({adding:true});
  }

  cancelAdd = () => {
    this.setState({adding:false});
  }

  startAddPmnt = e => {
    e.preventDefault();
    this.setState({addingPmnt:true});
  }

  cancelAddPmnt = () => {
    this.setState({addingPmnt:false});
  }

  render() {
    const { order, percs, comps, srvcs, srvgs, ctypes, tab, editPost,
      addSets, updtBlnc, posts } = this.props;

    const activeData = posts.filter(el => {
      if(el.post_active === 1){
        return true;
      }
      return false;
    });

    const sortD = activeData.sort( (a, b) => {
      if(srvcs[a.post_srvc_id].srvc_type < srvcs[b.post_srvc_id].srvc_type)
        return -1
      if(srvcs[a.post_srvc_id].srvc_type > srvcs[b.post_srvc_id].srvc_type)
        return 1
      if(
        a.post_payer === order.order_comp_id &&
        b.post_payer !== order.order_comp_id
      )
        return -1
      if(
        a.post_payer !== order.order_comp_id &&
        b.post_payer === order.order_comp_id
      )
        return 1
      if(a.post_sort < b.post_sort)
        return -1
      if(a.post_sort > b.post_sort)
        return 1
      if(a.post_desc < b.post_desc)
        return -1
      if(a.post_desc > b.post_desc)
        return 1
      if(a.post_id < b.post_id)
        return -1
      if(a.post_id > b.post_id)
        return 1
      return 0
    });

    const fltrD = sortD;

    var postG = {};
    var costG = {};
    var pmntG = {};
    var postSum = 0;
    var costSum = 0;
    let comission = 0;
    let tax = 0;
    const pmntLinkOptions = [];
    const pmnts = [];
    const orderPmnts = [];
    let orderPmntSum = 0;
    let orderPayedSum = 0;
    let orderPmntColor = 'black';
    const subT = [];
    const taxP = [];
    for (var i=0; i < fltrD.length; i++){
      const post = fltrD[i];
      const srvc = srvcs[post.post_srvc_id];
      if (post.post_payer === order.order_comp_id) {
        if(srvc.srvc_type === 1){
          if(srvgs[srvc.srvc_srvg_id].srvg_subtotal === 1){
            subT.push(post);
            comission += post.post_price * post.post_qntt;
            continue;
          }
          if(srvgs[srvc.srvc_srvg_id].srvg_subtotal === 2){
            taxP.push(post);
            tax += post.post_price * post.post_qntt;
            continue;
          }
          if (!postG.hasOwnProperty(post.post_srvg_id)){
            postG[post.post_srvg_id] = {
              priceSum: 0,
              costSum: 0,
              posts: []
            };
          }
          postG[post.post_srvg_id].posts.push(post);
          postG[post.post_srvg_id].priceSum += post.post_price * post.post_qntt;
          postSum += post.post_price * post.post_qntt;
        }
        else {
          orderPmnts.push(post);
          orderPmntSum += post.post_price * post.post_qntt;
          if(post.post_payed) {
            orderPayedSum += post.post_price * post.post_qntt;
          }
          else if(post.post_bdate <= moment().format('Y-MM-DD')) {
            orderPmntColor = 'red';
          }
        }
      }
      else {
        if(srvc.srvc_type === 1){
          if(srvgs[post.post_srvg_id].srvg_subtotal){
            continue;
          }
          if (!costG.hasOwnProperty(post.post_link)){
            costG[post.post_link] = {posts: [], pmnts: []};
          }
          costG[post.post_link].posts.push(post);
          postG[post.post_srvg_id].costSum += post.post_price * post.post_qntt;
          costSum += post.post_price * post.post_qntt;
          pmntG[post.post_id] = _.remove(pmnts, pmnt => {
            return pmnt.post_link === post.post_id;
          })
          pmntLinkOptions.push({
            value: post.post_id,
            label: post.post_desc,
            seller: post.post_seller
          });
        }
        else {
          pmnts.push(post);
        }
      }
    }

    var mappedData = [];
    var groupCount = 1;
    const srvgsArr = [];
    for (let key in srvgs){
      if(srvgs.hasOwnProperty(key)) {
        srvgsArr.push(srvgs[key]);
      }
    }
    srvgsArr.sort((a, b) => {
      if(a.srvg_sort < b.srvg_sort)
          return -1
      if(a.srvg_sort > b.srvg_sort)
          return 1
      if(a.srvg_desc < b.srvg_desc)
          return -1
      if(a.srvg_desc > b.srvg_desc)
          return 1
      return 0
    });

    for (let srvgIdx = 0; srvgIdx < srvgsArr.length; srvgIdx++){
      let key = ""+srvgsArr[srvgIdx].srvg_id;
      if(postG.hasOwnProperty(key)){
        mappedData.push(
          <tr className="warning" key={key+".1"}>
            <td>{groupCount}</td>
            <td>{srvgs[key].srvg_desc}</td>
            <td></td><td></td><td></td><td></td><td></td><td></td>
          </tr>
        );
        var itemCount = 1;
        for(let i = 0; i < postG[key].posts.length; i++){
          const post = postG[key].posts[i];
          mappedData.push(
            <PRSPostItem
              key={post.post_id}
              num={""+groupCount+"."+(itemCount++)}
              data={post}
              costs={costG[post.post_id] ? costG[post.post_id].posts : []}
              allPmnts={pmntG}
              updtBlnc={updtBlnc}
              srvcs={srvcs}
              ctypes={ctypes}
              srvgs={srvgs}
              comps={comps}
              editPost={editPost}
              addSets={addSets}
              tab={tab}
            />
          );
          if (costG[post.post_id] && (tab === 'cost' || tab === 'pmnt')) {
            for (let j = 0; j < costG[post.post_id].posts.length; j++) {
              const cost = costG[post.post_id].posts[j];
              mappedData.push(
                <PRSCostItem
                  key={cost.post_id}
                  data={cost}
                  pmnts={pmntG[cost.post_id]}
                  updtBlnc={updtBlnc}
                  srvcs={srvcs}
                  srvgs={srvgs}
                  ctypes={ctypes}
                  comps={comps}
                  editPost={editPost}
                  addSets={addSets}
                  tab={tab}
                />
              );
              if (tab === 'pmnt') {
                for (let k = 0; k < pmntG[cost.post_id].length; k++) {
                  const pmnt = pmntG[cost.post_id][k];
                  mappedData.push(
                    <PRSPmntItem
                      key={pmnt.post_id}
                      data={pmnt}
                      updtBlnc={updtBlnc}
                      srvcs={srvcs}
                      editPost={editPost}
                    />
                  )
                }
              }
            }
          }
        }
        mappedData.push(
          <tr key={key+".2"}>
            <th colSpan="2">Итого по группе</th>
            <th></th><th></th>
            <th className="text-right">{fnum(postG[key].priceSum)}</th>
            <th className="text-right info">
              {fnum(postG[key].costSum)}
            </th>
            <th className="text-right text-success">
              {fnum(postG[key].priceSum-postG[key].costSum)}
            </th>
            <th>
              {(postG[key].priceSum !== 0) ?
                fnum((postG[key].priceSum-postG[key].costSum)/postG[key].priceSum*100)
                : 0
              }% <small>рентабельность</small>
            </th>
          </tr>
        );
        groupCount++;
      }
    }

    const comissionCalc = order.order_perc_id && percs[order.order_perc_id].perc_perc !== 0
      ? postSum*percs[order.order_perc_id].perc_perc/100*percs[order.order_perc_id].perc_type
      : 0;

    const taxCalc = order.order_taxperc_id && percs[order.order_taxperc_id].perc_perc !== 0
      ? (postSum+comission)*percs[order.order_taxperc_id].perc_perc/100*percs[order.order_taxperc_id].perc_type
      : 0;

    return (
      <div>
        <div className="corner-add-button">
          <ul className="corner-add-button-popup">
            <a
              href="#"
              className="list-group-item list-group-item-warning"
              onClick={this.startAdd}
            >
              Добавить услугу
            </a>
            <a
              href="#"
              className="list-group-item list-group-item-success"
              onClick={this.startAddPmnt}
            >
              Добавить оплату
            </a>
          </ul>
          <div className="corner-add-button-icon">+</div>
        </div>
        <table className="table table-hover">
          <thead>
            <tr>
              <th>
                <div style={{width: '24px'}}>№</div>
              </th>
              <th className="col-xs-5">Наименование</th>
              <th className="text-right">
                <div style={{width: '63px'}}>Цена,<br />руб.</div>
              </th>
              <th className="text-right">Кол<br />во</th>
              <th className="text-right">
                <div style={{width: '63px'}}>Итого,<br />руб.</div>
              </th>
              <th className="text-right">
                <div style={{width: '63px'}}>Себес.,<br />руб.</div>
              </th>
              <th className="text-right">Выход,<br />руб.</th>
              <th className="col-xs-5">Оплата, заметка</th>
            </tr>
          </thead>
          <tbody>
            {mappedData}
            {this.state.adding && (
              <PRSAddPostForm
                data={{
                  post_srvc_id: 0,
                  post_desc: "",
                  post_order_id: order.order_id,
                  post_price: 0,
                  post_qntt: 1,
                  post_note: "",
                  post_active: 1,
                  post_seller:order.order_comp1_id,
                  post_payer:order.order_comp_id,
                  post_bdate:order.order_edate,
                  post_avans: 1,
                  post_payed: 0,
                  post_sort: 0,
                  post_srvg_id: 0,
                  cost_seller: 117,
                  cost_price: 0,
                  cost_qntt: 1
                }}
                srvcs={srvcs}
                srvgs={srvgs}
                ctypes={ctypes}
                comps={comps}
                cancelAdd={this.cancelAdd}
                updtBlnc={updtBlnc}
                editPost={editPost}
                addSets={addSets}
              />
            )}
            {(tab === 'pmnt' && pmnts.length > 0) && (
              <tr className="success">
                <td></td>
                <td><b>Не разнесенные оплаты</b></td>
                <td></td><td></td><td></td><td></td><td></td><td></td>
              </tr>
            )}
            {tab === 'pmnt' && pmnts.map(pmnt => {
              return(
                <PRSPmntItem
                  key={pmnt.post_id}
                  data={pmnt}
                  pmntLinkOptions={pmntLinkOptions}
                  updtBlnc={updtBlnc}
                  srvcs={srvcs}
                  editPost={editPost}
                  addSets={addSets}
                />
              );
            })}
            {(subT.length > 0) ? (
              <tr className="info">
                <th colSpan="2">Подитог</th>
                <th></th><th></th>
                <th className="text-right">{fnum(postSum)}</th>
                <th className="text-right info">{fnum(costSum)}</th>
                <th className="text-right text-success">{fnum(postSum-costSum)}</th>
                <th>
                  {
                    (postSum !== 0) ?
                    fnum((postSum-costSum)/postSum*100)
                    : 0
                  }% <small>рентабельность</small>
                </th>
              </tr>
            ) : (
              <PRSSubTotalItem
                srvcs={srvcs}
                srvgs={srvgs}
                preSum={comissionCalc}
                data={{post_price: 0, post_qntt: 0}}
                order={order}
                updtBlnc={updtBlnc}
                editPost={editPost}
                type={1}
              />
            )}
            {subT.map(post => {
              return (
                <PRSSubTotalItem
                  key={post.post_id}
                  srvcs={srvcs}
                  srvgs={srvgs}
                  preSum={comissionCalc}
                  data={post}
                  order={order}
                  updtBlnc={updtBlnc}
                  editPost={editPost}
                  type={1}
                />
              )
            })}
            {(taxP.length > 0) ? (
              <tr className="success">
                <th colSpan="2">Подитог без налога</th>
                <th></th><th></th>
                <th className="text-right">{fnum(postSum+comission)}</th>
                <th className="text-right info">{fnum(costSum)}</th>
                <th className="text-right text-success">{fnum(postSum+comission-costSum)}</th>
                <th>
                  {
                    (postSum+comission !== 0) ?
                    fnum((postSum+comission-costSum)/(postSum+comission)*100)
                    : 0
                  }% <small>рентабельность</small>
                </th>
              </tr>
            ) : (
              <PRSSubTotalItem
                srvcs={srvcs}
                srvgs={srvgs}
                preSum={taxCalc}
                data={{post_price: 0, post_qntt: 0}}
                order={order}
                updtBlnc={updtBlnc}
                editPost={editPost}
                type={2}
              />
            )}
            {taxP.map(post => {
              return (
                <PRSSubTotalItem
                  key={post.post_id}
                  srvcs={srvcs}
                  srvgs={srvgs}
                  preSum={taxCalc}
                  data={post}
                  order={order}
                  updtBlnc={updtBlnc}
                  editPost={editPost}
                  type={2}
                />
              )
            })}
          </tbody>
          <tfoot>
            <tr>
              <th colSpan="2">Итог</th>
              <th></th><th></th>
              <th className="text-right">
                {fnum(postSum+comission+tax)}
              </th>
              <th className="text-right info">{fnum(costSum)}</th>
              <th className="text-right text-success">
                {fnum(postSum-costSum+comission+tax)}
              </th>
              <th>
                {
                  (postSum+comission+tax !== 0) ?
                  fnum((postSum+comission+tax-costSum)/(postSum+comission+tax)*100)
                  : 0
                }%{" "}
                <small>
                  рентабельность, для гос. заказов{" "}
                  {fnum((postSum+comission+tax)/1.1 - costSum)}
                </small>
              </th>
            </tr>
          </tfoot>
        </table>
        <h2>Оплата заказа</h2>
        <div>
          {orderPmntSum !== postSum+comission+tax && (
            <span style={{color: 'red'}}>
              Долг {fnum(postSum+comission+tax - orderPmntSum)}.{" "}
            </span>
          )}
          {orderPayedSum !== orderPmntSum && (
            <span style={{color: orderPmntColor}}>
              Oплатить {fnum(orderPmntSum - orderPayedSum)}
            </span>
          )}
        </div>
        <table className="table table-hover">
          <thead>
            <tr>
              <th>
                <div style={{width: '24px'}}>№</div>
              </th>
              <th className="col-xs-5">Наименование</th>
              <th className="text-right">
                <div style={{width: '63px'}}>Цена,<br />руб.</div>
              </th>
              <th className="text-right">Кол<br />во</th>
              <th className="text-right">
                <div style={{width: '63px'}}>Итого,<br />руб.</div>
              </th>
              <th className="text-right">
                <div style={{width: '63px'}}>Себес.,<br />руб.</div>
              </th>
              <th className="text-right">Выход,<br />руб.</th>
              <th className="col-xs-5">Оплата, заметка</th>
            </tr>
          </thead>
          <tbody>
            {orderPmnts.map(pmnt => {
              return(
                <PRSPmntItem
                  key={pmnt.post_id}
                  data={pmnt}
                  updtBlnc={updtBlnc}
                  srvcs={srvcs}
                  orderPayment
                  editPost={editPost}
                />
              );
            })}
            <tr onClick={this.startAddPmnt}>
              <td></td>
              <td><u>Нажмите, чтобы добавить оплату</u></td>
              <td></td><td></td><td></td><td></td><td></td><td></td>
            </tr>
          </tbody>
        </table>
      {this.state.addingPmnt && (
        <PRSAddPmntForm
          data={{
            post_srvc_id: 0,
            post_desc: 'Оплата заказа № ' + order.order_num,
            post_order_id: order.order_id,
            post_price: postSum+comission+tax - orderPmntSum,
            post_qntt: 1,
            post_note: "",
            post_active: 1,
            post_seller: order.order_comp1_id,
            post_payer: order.order_comp_id,
            post_bdate: order.order_edate,
            post_avans: 1,
            post_payed: 0
          }}
          cancelAdd={this.cancelAddPmnt}
          costDesc="Всего заказа"
          updtBlnc={updtBlnc}
          orderPayment
          editPost={editPost}
          srvcs={srvcs}
        />
      )}
      </div>
    )

  }
}

PRSForm.propTypes = {
  posts: PropTypes.array.isRequired,
  order: PropTypes.object.isRequired,
  percs: PropTypes.object.isRequired,
  comps: PropTypes.object.isRequired,
  srvcs: PropTypes.object.isRequired,
  srvgs: PropTypes.object.isRequired,
  tab: PropTypes.string.isRequired,
  editPost: PropTypes.func.isRequired,
  addSets: PropTypes.func.isRequired,
  updtBlnc: PropTypes.func.isRequired
}

export default PRSForm;



// WEBPACK FOOTER //
// ./src/components/prs/PRSForm.js